import { render } from "./QrCategoryPage.vue?vue&type=template&id=bf17e1bc"
import script from "./QrCategoryPage.vue?vue&type=script&lang=js"
export * from "./QrCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__